import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { EMAIL_REGEX, PHONE_NUMBER_REGEX } from "./constants.ts";

export const ContactUsFormValidation = () => {
    const {t} = useTranslation();
    
    return Yup.object().shape({
        firstName: Yup.string()
            .trim()
            .required(t('FORM.FIRST_NAME_REQUIRED'))
            .min(2, t('FORM.FIRST_NAME_SIZE_LIMIT'))
            .max(50, t('FORM.FIRST_NAME_SIZE_LIMIT')),
        lastName: Yup.string()
            .trim()
            .required(t('FORM.LAST_NAME_REQUIRED')),
        email: Yup.string()
            .trim()
            .required(t('FORM.EMAIL_ID_REQUIRED'))
            .matches(EMAIL_REGEX, t('FORM.INVALID_EMAIL_ADDRESS')),
        country: Yup.object().shape({
                value: Yup.string().required(t('FORM.COUNTRY_REQUIRED')),
                label: Yup.string()
            })
            .required(),
        msisdn: Yup.object({
            countryCode: Yup.string(),
            phoneNumber: Yup.string()
                .matches(PHONE_NUMBER_REGEX, t('FORM.PHONE_NUMBER_LENGTH'))
        }),
        message: Yup.string()
            .trim()
            .required(t('FORM.MESSAGE_REQUIRED')),
        // isPrivacyPolicyChecked: Yup.boolean()
        //     .required(t('FORM.ACCEPT_PRIVACY_POLICY_TO_CONTINUE'))
    });
};